export enum VehicleCategory {
  WithoutTrailer = "withoutTrailer",
  WithTrailer = "withTrailer",
}

export const mapToVehicleCategoryType = (
  trailer?: boolean,
): VehicleCategory | undefined => {
  return trailer ? VehicleCategory.WithTrailer : VehicleCategory.WithoutTrailer;
};
